import axios from './defaultClient';

const nameSpace = '/ep/v1/global';
export const GetMainSections = async (args) => {
    return await axios.get( nameSpace + '/main_sections/',{})
}